import React from 'react';
import {Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import { ReactComponent as UploadIcon } from '../../../../assets/icons/upload_ocr.svg';
import {
    DragDropArea,
    FullWidthUpload,
    IconCircle,
    MiniDragDropArea,
    MiniIconCircle,
    MiniUploadWrapper
} from "./FileDropZone.styled";
import {theme, tokens} from "../../../../theme";

interface FileDropZoneProps {
    inputRef: React.RefObject<HTMLInputElement>;
    isDragging: boolean;
    setIsDragging: React.Dispatch<React.SetStateAction<boolean>>;
    onDrop: (e: React.DragEvent) => void;
    variant?: 'full' | 'mini';
}

const FileDropZone = ({inputRef, isDragging, setIsDragging, onDrop, variant}: FileDropZoneProps) => {
    const { t } = useTranslation();

    const handleClick = () => inputRef.current?.click();
    const handleDragOver = (e: React.DragEvent) => { e.preventDefault(); setIsDragging(true); };
    const handleDragLeave = () => setIsDragging(false);

    if (variant === 'mini') {
        return (
            <MiniUploadWrapper>
                <MiniDragDropArea
                    disableRipple
                    onClick={handleClick}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={onDrop}
                    $isDragging={isDragging}
                    aria-label={t('ocr.aria.dragDropArea')}
                >
                    <MiniIconCircle>
                        <UploadIcon style={{ width: 16, height: 16, opacity: 0.5 }} aria-hidden="true" />
                    </MiniIconCircle>

                    <Typography variant="body2" fontWeight={tokens.fontWeight.medium} sx={{ color: theme.palette.text.primary }}>
                        {t('ocr.upload.click')}
                    </Typography>

                    <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                        {t('ocr.upload.supportedFileTypes')}
                    </Typography>
                </MiniDragDropArea>
            </MiniUploadWrapper>
        );
    }

    return (
        <FullWidthUpload>
            <DragDropArea
                disableRipple
                onClick={() => inputRef.current?.click()}
                onDragOver={(e) => {
                    e.preventDefault();
                    setIsDragging(true);
                }}
                onDragLeave={() => setIsDragging(false)}
                onDrop={onDrop}
                $isDragging={isDragging}
                aria-label={t('ocr.aria.dragDropArea')}
            >
                <IconCircle>
                    <UploadIcon aria-hidden="true" />
                </IconCircle>

                <Typography variant="body1" fontWeight={tokens.fontWeight.medium} sx={{ color: theme.palette.text.primary }}>
                    {t('ocr.upload.click')}
                </Typography>

                <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                    {t('ocr.upload.supportedFileTypes')}
                </Typography>

            </DragDropArea>
        </FullWidthUpload>
    );
};

export default FileDropZone;